const METHODS: ReadonlyArray<{ label: string; dot: string }> = [
  { label: 'Orange Money', dot: 'bg-terracotta-500' },
  { label: 'MTN MoMo', dot: 'bg-[#FFCC00]' },
  { label: 'Wave', dot: 'bg-blue-500' },
  { label: 'Virement', dot: 'bg-charcoal-700' },
  { label: 'CB internationale', dot: 'bg-lime-500' },
];

export default function PaymentStripV2() {
  return (
    <section className="border-y-2 border-charcoal-800 bg-white py-8">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-6 md:flex-row md:px-8">
        <div className="inline-flex items-center gap-3 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-500">
          <span className="h-px w-7 bg-lime-500" />
          Paiements acceptés · XAF / XOF
        </div>
        <ul className="flex flex-wrap items-center gap-3 md:gap-4">
          {METHODS.map((m) => (
            <li
              key={m.label}
              className="inline-flex items-center gap-2 border-2 border-charcoal-800 bg-paper px-3 py-1.5 font-marketing-display text-[12.5px] font-bold text-charcoal-800 shadow-neobrutal-2"
            >
              <span className={`h-2 w-2 rounded-full border border-charcoal-800 ${m.dot}`} />
              {m.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
